import axios from "axios";
const CONTROLLER_PATH = "Claim";
class ClaimService {
    //CREATE
    create(claim) {
        return axios.post(CONTROLLER_PATH, claim).then((response) => response.data);
    }

    generateClaimBatch(id, body) {
        return axios.post(CONTROLLER_PATH + "/GenerateClaimBatch/" + id, body).then((response) => response.data);
    }
    addNote(claimId, text) {
        return axios.put(CONTROLLER_PATH + "/" + claimId + "/addNote", { text: text }).then((response) => response.data);
    }
    //READ
    get(id, urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + (id ? "/" + id : ""), { params: urlParameters, requestId: requestId }).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }

    getClaimPreSubmissionFormDto(id, urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + "/GetClaimPreSubmissionFormDto" + (id ? "/" + id : ""), { params: urlParameters, requestId: requestId }).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }

    getreducedview(id, urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + "/GetReducedView" + (id ? "/" + id : ""), { params: urlParameters, requestId: requestId }).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }

    getNonValidated(id, urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + "/GetNonValidated", { params: urlParameters, requestId: requestId }).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }

    getAgeing(urlParameters) {
        return axios.get(CONTROLLER_PATH + "/ageing", { params: urlParameters }).then((response) => response.data);
    }

    getageingmanagement(urlParameters) {
        return axios.get(CONTROLLER_PATH + "/getageingmanagement", { params: urlParameters }).then((response) => response.data);
    }

    getclaimsubmissionmanagementwidgetdto(urlParameters) {
        return axios.get(CONTROLLER_PATH + '/getclaimsubmissionmanagementwidgetdto', {params: urlParameters}).then((response) => response.data);
    }

    getclaimpaymentmanagementwidgetdto(urlParameters) {
        return axios.get(CONTROLLER_PATH + '/getclaimpaymentmanagementwidgetdto', {params: urlParameters}).then((response) => response.data);
    }

    getPreSubmissionClaims() {
        return axios.get(CONTROLLER_PATH + "/getPreSubmissionClaims").then((response) => response.data);
    }

    getclaimpostsubmissionformdto(id, requestId, urlParameters) {
        return axios.get(CONTROLLER_PATH + "/getclaimpostsubmissionformdto/" + id, { params: urlParameters, requestId: requestId }).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }

    getStatuses() {
        return axios.get(CONTROLLER_PATH + "/getStatuses").then((response) => response.data);
    }

    //UPDATE
    update(claim) {
        return axios.put(CONTROLLER_PATH + "/" + claim.id, claim).then((response) => response.data);
    }

    setPrintedVerified(id, isPrintedVerified) {
        return axios.post(CONTROLLER_PATH + "/SetPrintedVerified", null, { params: { id, isPrintedVerified } }).then((response) => response.data);
    }

    updateClaimPostSubmissionDetails(id, formData) {
        return axios
            .put(CONTROLLER_PATH + "/updateClaimPostSubmissionDetails/" + id, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }
    claimlinknumberstatusimport(form) {
        return axios
            .post(CONTROLLER_PATH + "/claimlinknumberstatusimport", form, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }
    //DELETE
    delete(id) {
        return axios.delete(CONTROLLER_PATH + "/" + id).then(() => {});
    }

    //CLAIM FILES
    //CREATE
    createFile(claimId, formdata) {
        return axios
            .post(CONTROLLER_PATH + "/" + claimId + "/file", formdata, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }
    //READ
    getClaimFiles(claimId) {
        return axios.get(CONTROLLER_PATH + "/GetClaimFiles" + "/" + claimId).then((response) => response.data);
    }
    getFileTypes() {
        return axios.get(CONTROLLER_PATH + "/getFileTypes").then((response) => response.data);
    }
    //UPDATE
    updateFile(entity) {
        return axios.put(CONTROLLER_PATH + "/" + entity.claimId + "/file/" + entity.id, entity).then((response) => response.data);
    }
    //DELETE
    deleteFile(claimId, claimFileId) {
        return axios.delete(CONTROLLER_PATH + "/" + claimId + "/file/" + claimFileId).then((response) => response.data);
    }
}

export default new ClaimService();
